import {
  ElementRef,
  Component,
  OnInit,
  AfterContentInit,
  OnDestroy,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  InsaService,
  ClientContactService,
  AuthService,
  LocalizeService,
} from "../../insa-services";
import { UserModel, CurrencyModel, ClientModel } from "../../insa-models";
import { appStateProvider } from "../../insa-providers";
//import { ReportModel } from '../../insa-models/report.model'
import {
  SharedMethodsModule,
  MultiSelectCustomModule,
} from "../../insa-custom-scripts";
import { appConfig } from "../../../insaweb.config";
//import { Locale } from 'core-js/library/web/timers';

@Component({
  selector: "insaweb-settings",
  templateUrl: "settings.component.html",
})
export class SettingsComponent implements OnInit, AfterContentInit, OnDestroy {
  layoutBlackImg = require('../../../Images/layout_black.png');
  layoutWhiteImg = require('../../../Images/layout_white.png');

  private currencies: any; //  CurrencyModel[] = new Array<CurrencyModel>(); holi
  private selectedCurrency = { value: 0, text: "" };
  private multiselectClientPortfolios = new Array<ClientModel>();
  private selectByPartner = new Array<Object>();
  private sortPartnerDropdown = [];
  private selectedPortfolios: ClientModel[] = new Array<ClientModel>();
  private selectedPartner = { value: 0, text: "" };
  private startDate: Date;
  private endDate: Date;
  private currenciesLoaded: boolean = false;
  private userInfoLoaded: boolean = false;
  private userHasInsaUserRole: boolean = false;
  private currAnalysisSubscription;
  private assetCategorySubscription;
  private performanceChartSubscription;
  private transVolumeSubscription;
  private portfDetailsSubscription;
  private crossRatesSubscription;
  private transSubscription;
  private portfolioSubscription;
  private newsSubscription;
  private reportSubscription;
  private report;
  private isMobileDevice: boolean;
  private clientContactsSubscription;
  private hideIncludeIgnored = appConfig.hideIncludeIgnoredTransactions;
  private showThemeSelection = appConfig.showThemeSelection || false; // false if undefined
  private separatePositionsByPortfolioVisible =
    appConfig.separatePositionsByPortfolioVisible;
  private includeClosedPortfoliosVisible =
    appConfig.includeClosedPortfoliosVisible;
  private consolidateAllPositionsVisible = appConfig.consolidateAllPositionsVisible;
  private loadingTextStatus = "select"; // or 'loading'
  private languageLoading = false;
  private languages = [];
  private hideWelcomeMessage = false;
  private isReportByPartner = false;
  private autoConfirmTriggered = false;
  private filterVisible = !(appConfig.initialSettings && appConfig.initialSettings?.enabled);
  welcomeMessage: string = appConfig.WelcomeMessage;
  languageChangeVisible: boolean =
    appConfig.showLanguageChangeButtonOnLogin === undefined
      ? true
      : appConfig.showLanguageChangeButtonOnLogin;
  // Settings -> Special Functions -> Change Password. Same appConfig-driven
  // visibility pattern as the login screen buttons (default: visible).
  passwordChangeInSettingsVisible: boolean =
    (appConfig as any).showPasswordChangeInSettings === undefined
      ? false
      : (appConfig as any).showPasswordChangeInSettings;
  passwordChangeRequesting = false;
  public userInfo: UserModel;
  processingOnPortfolioLevel = false;
  consolidateAllPositions = false;

  constructor(
    private _authService: AuthService,
    private _insaService: InsaService,
    private _clientContactService: ClientContactService,
    private zone: NgZone,
    private _appStateProvider: appStateProvider,
    private _localize: LocalizeService,
    private _element: ElementRef,
    private _router: Router,
  ) {
    window["settingsComponentRef"] = {
      zone: this.zone,
      component: this,
    };
    this.assetCategorySubscription =
      this._insaService.AssetCategoryChartEvent.subscribe((assetCategory) =>
        kendo.ui.progress($(".donutChart-loading"), false),
      );
    this.currAnalysisSubscription =
      this._insaService.CurrencyAnalysisChartEvent.subscribe((currAnalysis) =>
        kendo.ui.progress($(".donutChart-loading"), false),
      );
    this.performanceChartSubscription =
      this._insaService.PerformanceDetailsChartEvent.subscribe((perfDetails) =>
        kendo.ui.progress($(".barChart-loading"), false),
      );
    this.transVolumeSubscription =
      this._insaService.TransactionsVolumeChangedEvent.subscribe(
        (perfDetails) => kendo.ui.progress($(".transList-loading"), false),
      );
    this.portfDetailsSubscription =
      this._insaService.PortfolioPerformanceDetailsEvent.subscribe(
        (perfDetails) => kendo.ui.progress($(".portfList-loading"), false),
      );
    this.crossRatesSubscription =
      this._insaService.CrossRatesChangedEvent.subscribe((crossRates) => {
        (kendo.ui.progress($(".crossRatesPortal-loading"), false),
          kendo.ui.progress($(".crossRates-loading"), false));
      });
    this.transSubscription =
      this._insaService.TransactionsChangedEvent.subscribe((trans) =>
        kendo.ui.progress($(".transGrid-loading"), false),
      );
    this.portfolioSubscription = this._insaService.PortfolioEvent.subscribe(
      (portf) => kendo.ui.progress($(".portfGrid-loading"), false),
    );
    this.newsSubscription = this._insaService.NewsDataEvent.subscribe((news) =>
      kendo.ui.progress($(".news-loading"), false),
    );
    this.clientContactsSubscription =
      this._clientContactService.ClientContactsEvent.subscribe((contact) =>
        kendo.ui.progress($(".contacts-loading"), false),
      );
    //this.clientContactsSubscription = this._clientContactService.ClientContactsEvent.subscribe(contact => kendo.ui.progress($(".jobGrid-loading"), false));
    this.reportSubscription = this._insaService.CreateReportEvent.subscribe(
      (report) => {
        this.loadingTextStatus = "select";
        this.report = report;

        //this needs to be done in order to proper finished animation on both: small and big sevices... update by Filip: had to comment this out since the animation would not stop if the window was resized in the meantime...
        // (window.innerWidth <=768) ? kendo.ui.progress($(".reportViewer-loading"), false): console.log("I'm on desktop mood!")
        kendo.ui.progress($(".reportViewer-loading"), false); //
        setTimeout(this._appStateProvider.updateLayout.bind(this), 500);
      },
    );
    // this.secPricesSupscription = this._insaService.SecurityPricesChartEvent.subscribe(secPrices =>  kendo.ui.progress($(".stockChart-loading"), false));
  }

  ngAfterViewInit() {
    const loadLanguages = () => {
      this.languages = this._localize
        .getAvailableLocalesWithFriendlyNames()
        .filter((l) => l.locale !== this._localize.getLocale());
    };

    loadLanguages();
    this._localize.LocaleChangedEmmiter.subscribe(() => loadLanguages());
    this._localize.applyTranslations(this._element.nativeElement);
  }

  private getCurrencies() {
    this._insaService.getCurrencies().subscribe((data) => {
      const available = appConfig.initialSettings?.availableCurrencies;
      if (available && available !== "all") {
        const allowed = available.split(",").map((c: string) => c.trim());
        this.currencies = data.filter((c: any) => allowed.includes(c.CurrShort));
      } else {
        this.currencies = data;
      }
      this.initCurrencyDropdown();
      this.currenciesLoaded = true;
      if (
        !appConfig.initialSettings?.enabled &&
        !(
          this.userHasInsaUserRole &&
          this.multiselectClientPortfolios.length > 1
        )
      ) {
        MultiSelectCustomModule.onMultiselectPortfoliosChange(undefined);
        this.initDataFetching();
      }
      this.tryAutoConfirm();
    });
  }

  private initCurrencyDropdown() {
    let dropdownOptions: kendo.ui.DropDownListOptions = {};
    dropdownOptions.dataTextField = "CurrShort";
    dropdownOptions.dataValueField = "CurrIndex";
    dropdownOptions.dataSource = this.currencies;
    $("#currency").kendoDropDownList(dropdownOptions);
  }

  private getUserInfo() {
    this._authService.getUserInfo().subscribe((data: UserModel) => {
      this.userInfo = data;

      let allPartners: Object = {
        PartnerIndex: 0,
        Number: this._localize.getTranslation("ALL"),
      };

      for (var key in this.userInfo.PartnersList) {
        let numberkey: number = +key;
        let Partneritem: Object = {
          PartnerIndex: numberkey,
          Number: this.userInfo.PartnersList[numberkey],
        };
        this.selectByPartner.push(Partneritem);
      }

      //sorting in dropdown in ascending order (same as in Silverlight)
      this.sortPartnerDropdown = this.selectByPartner.slice(0);
      this.sortPartnerDropdown.sort(function (a, b) {
        var x = a.Number.toLowerCase();
        var y = b.Number.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });

      //add All partners at the beginning of the sorted array
      this.sortPartnerDropdown.splice(0, 0, allPartners);
      this.sortPartnerDropdown.join();

      MultiSelectCustomModule.KendoPartnerDropdown(
        "#partner",
        this.sortPartnerDropdown,
        "Number",
        "PartnerIndex",
      );
      this.multiselectClientPortfolios = data.Portfolios;
      MultiSelectCustomModule.KendoPortfolioMultiSelect(
        "#portfoliosMultiSelect",
        this.multiselectClientPortfolios,
        "Number",
        "Index",
        "CloseDate",
      );
      this.userHasInsaUserRole = this.userInfo.Roles.indexOf("InsaUser") >= 0;
      this.userInfoLoaded = true;
      if (
        this.userHasInsaUserRole &&
        this.multiselectClientPortfolios !== undefined &&
        this.multiselectClientPortfolios.length > 1
      ) {
        this.loadingTextStatus = "select";
        $("#portfoliosMultiSelect").data("kendoMultiSelect").value([]);
        $("#checkAll").prop("checked", false);
        $(".multiSelectPortfolios").prop("checked", false);
      } else if (!appConfig.initialSettings?.enabled) {
        this.initDataFetching();
        //MAJA: when there is only one portfolio to load, filter need sto be collapsed
        //this feature was initially set
        $("#filter").collapse("hide");
      }
      //this._appStateProvider.updateLayout();
      this.tryAutoConfirm();
    });
  }

  private checkIfIncludeIgnored() {
    if ($("#ignoredTransactions").is(":checked")) {
      this._appStateProvider.includeIgnoredTransactions = true;
    } else {
      this._appStateProvider.includeIgnoredTransactions = false;
    }
  }

  private setLoadingIndicators(boolState) {
    kendo.ui.progress($(".donutChart-loading"), boolState);
    // kendo.ui.progress($(".stockChart-loading"), boolState);
    kendo.ui.progress($(".transList-loading"), boolState);
    kendo.ui.progress($(".barChart-loading"), boolState);
    kendo.ui.progress($(".portfList-loading"), boolState);
    kendo.ui.progress($(".crossRates-loading"), boolState);
    kendo.ui.progress($(".crossRatesPortal-loading"), boolState);
    kendo.ui.progress($(".news-loading"), boolState);
    kendo.ui.progress($(".transGrid-loading"), boolState);
    kendo.ui.progress($(".portfGrid-loading"), boolState);
    kendo.ui.progress($(".chartList-loading"), boolState);
    kendo.ui.progress($(".contacts-loading"), boolState);
    kendo.ui.progress($(".reportViewer-loading"), boolState);
  }

  private emitRefreshChange() {
    this.setLoadingIndicators(true);
    this._appStateProvider.emit("App refresh triggered!");
  }

  private removeOnMobileDevice() {
    if (window.innerWidth < 768) {
      this.isMobileDevice = true;
      $("#overviewMobileIndicator").addClass("reportViewer-loading");
    } else {
      this.isMobileDevice = false;
    }
  }

  private onResize(event) {
    this.removeOnMobileDevice();
  }

  private updateLayoutSettings() {
    this._appStateProvider.updateLayout();
  }

  private validateInputs() {
    this.startDate = $("#StartDatePicker").data("kendoDatePicker").value();
    this.endDate = $("#EndDatePicker").data("kendoDatePicker").value();
    this.selectedPortfolios = this.getMultiselectValue(
      "#portfoliosMultiSelect",
    );
    this.selectedPartner = this.getDropdownValue("#partner");

    let criteriaAllowNoPortfolio =
      this.startDate !== null &&
      this.endDate !== null &&
      this.startDate <= this.endDate &&
      (this.selectedPartner.value !== 0 || this.selectedPortfolios.length > 0);
    let defaultCriteria =
      this.startDate !== null &&
      this.endDate !== null &&
      this.startDate <= this.endDate &&
      this.selectedPortfolios.length > 0;
    return appConfig.menuShowRiskProfile || appConfig.menuShowClientContacts
      ? criteriaAllowNoPortfolio
      : defaultCriteria;
  }

  private confirmClick() {
    if (this.validateInputs()) {
      this.hideWelcomeMessage = true;
    }
    this.initDataFetching();
  }

  initDataFetching() {
    // this._insaService.clearData();
    if (this.currenciesLoaded && this.userInfoLoaded) {
      setTimeout(this.updateLayoutSettings.bind(this), 200);
      // document.getElementById("loadingText").innerHTML = 'Loading Data...';
      this.loadingTextStatus = "loading";
      this.removeOnMobileDevice();
      if (this.validateInputs()) {
        this.startDate;
        this.endDate;
        this.selectedCurrency = this.getDropdownValue("#currency");
        this.updateAppState();
        this.emitRefreshChange();
      } else {
        this.loadingTextStatus = "select";
        SharedMethodsModule.addNotification(
          "#notificationDate",
          this._localize.getTranslation(
            "Invalid Date format or portfolio isn't selected!",
          ),
          false,
        );
        this.setLoadingIndicators(false);
        event.stopPropagation();
      }
    }
  }

  getDropdownValue(dropDownControlName: string) {
    let dropdown: kendo.ui.DropDownList =
      $(dropDownControlName).data("kendoDropDownList");
    let value: number = +dropdown.value();
    let text = dropdown.text();
    return { value, text };
  }

  getMultiselectValue(multiseletControlName: string) {
    let multiSelect: kendo.ui.MultiSelect = $(multiseletControlName).data(
      "kendoMultiSelect",
    );
    return multiSelect.value();
  }

  initDatePickers() {
    let pickersAnimation: kendo.ui.DatePickerAnimation = {};
    pickersAnimation.close = {};
    pickersAnimation.close.duration = 300;
    pickersAnimation.close.effects = "fadeOut zoom:out";
    pickersAnimation.open = {};
    pickersAnimation.open.duration = 300;
    pickersAnimation.open.effects = "fadeIn zoom:in";

    let pickerOptions: kendo.ui.DatePickerOptions = {};
    pickerOptions.animation = pickersAnimation;
    pickerOptions.format = "dd.MM.yyyy";
    pickerOptions.min = new Date(2000, 0, 1);
    pickerOptions.value = this.startDate;
    pickerOptions.culture = this._localize.getLocale();

    $("#StartDatePicker").kendoDatePicker(pickerOptions);

    pickerOptions.value = this.endDate;
    $("#EndDatePicker").kendoDatePicker(pickerOptions);
  }

  updateAppState() {
    this._appStateProvider.startDate = this.startDate;
    this._appStateProvider.endDate = this.endDate;
    this._appStateProvider.selectedCurrency = this.selectedCurrency;
    this._appStateProvider.selectedPartner = this.selectedPartner;
    this._appStateProvider.forceProcessingOnPortfolioLevel = false;
    this._appStateProvider.forceConsolidateAllPositions = false;
    // decide type of reportByPartner - only if nobody unclicked some portfolios
    let showClosed = $("#showClosedCheckbox").is(":checked"); // not adding binding to keep off any potential side effects
    this.processingOnPortfolioLevel = $(
      "#processingOnPortfolioLevelCheckbox",
    ).is(":checked"); // not adding binding to keep off any potential side effects
    this.consolidateAllPositions = $(
      "#consolidateAllPositionsCheckbox",
    ).is(":checked");
    if (this.processingOnPortfolioLevel) {
      //force this as opposed to trying to determine whether to go the consolidated or partner level
      this._appStateProvider.reportByPartner = false;
      this._appStateProvider.forceProcessingOnPortfolioLevel = true;
    }
    else if(this.consolidateAllPositions){
      this._appStateProvider.reportByPartner = false;
      this._appStateProvider.forceProcessingOnPortfolioLevel = false;
      this._appStateProvider.forceConsolidateAllPositions = true;
    }
    else {
      if (
        (!this.userHasInsaUserRole &&
          (this.selectedPortfolios.length === 0 ||
            this.selectedPortfolios.length ===
              this.multiselectClientPortfolios.filter((cp) =>
                showClosed ? true : cp.CloseDate === null,
              ).length)) ||
        (this._appStateProvider.selectedPartner.value !== 0 &&
          this.userHasInsaUserRole &&
          (this.selectedPortfolios.length === 0 ||
            this.selectedPortfolios.length ===
              this.multiselectClientPortfolios.filter(
                (cp) =>
                  cp.PartnerIndex === this.selectedPartner.value &&
                  (showClosed ? true : cp.CloseDate === null),
              ).length))
      ) {
        this._appStateProvider.reportByPartner = true;
        if (!this.userHasInsaUserRole) {
          this._appStateProvider.selectedPartner = {
            value: this.userInfo.PartnerIndex,
            text: "Self",
          };
        }
      } else {
        this._appStateProvider.reportByPartner = false;
      }
    }

    this.isReportByPartner = this._appStateProvider.reportByPartner;
    this._appStateProvider.selectedPortfolios = this.selectedPortfolios;
    this._appStateProvider.fetchingAssetCategory = true;
    this._appStateProvider.fetchingCurrAnalysis = true;
    this._appStateProvider.fetchingPerfomanceBarChart = true;
    // this._appStateProvider.fetchingPortfolioDetails = true;
    //this._appStateProvider.fetchingSecurityPrices = true;
    // this._appStateProvider.fetchingCrossRates = true;
    // this._appStateProvider.fetchingTransVolume = true;
    // this._appStateProvider.fetchingTransactions = true;
    // this._appStateProvider.fetchingPortfolios = true;
    this._appStateProvider.fetchingNews = true;
    // this._appStateProvider.fetchingReport = true;
    // this._appStateProvider.fetchingPDF = true;
    this._appStateProvider.fetchingClientContacts = true;
  }

  private resolveDate(dateSetting: string): Date {
    const today = new Date();
    switch (dateSetting) {
      case "startOfYear":
        return new Date(today.getFullYear(), 0, 1);
      case "endOfYear":
        return new Date(today.getFullYear(), 11, 31);
      case "today":
        return new Date();
      default:
        return new Date(dateSetting);
    }
  }

  private applyInitialSettingsToDropdowns() {
    if (appConfig.initialSettings.currency !== "all") {
      const currencyDropdown = $("#currency").data("kendoDropDownList");
      if (currencyDropdown && this.currencies) {
        const currency = this.currencies.find(
          (c) => c.CurrShort === appConfig.initialSettings.currency,
        );
        if (currency) {
          currencyDropdown.value(currency.CurrIndex);
        }
      }
    }

    const partnerDropdown = $("#partner").data("kendoDropDownList");
    if (partnerDropdown) {
      if (appConfig.initialSettings.partner === "all") {
        partnerDropdown.value(0);
      } else {
        const partner = this.sortPartnerDropdown.find(
          (p: any) => p.Number === appConfig.initialSettings.partner,
        );
        if (partner) {
          partnerDropdown.value((partner as any).PartnerIndex);
        }
      }
    }

    const multiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
    if (multiSelect) {
      if (appConfig.initialSettings.portfolios === "all") {
        const allValues = this.multiselectClientPortfolios.map(
          (p: any) => p.Index,
        );
        multiSelect.value(allValues);
      }
    }

    const startPicker = $("#StartDatePicker").data("kendoDatePicker");
    const endPicker = $("#EndDatePicker").data("kendoDatePicker");
    if (startPicker) startPicker.value(this.startDate);
    if (endPicker) endPicker.value(this.endDate);
  }

  private tryAutoConfirm() {
    if (
      !appConfig.initialSettings?.enabled ||
      !this.currenciesLoaded ||
      !this.userInfoLoaded ||
      this.autoConfirmTriggered
    ) {
      return;
    }
    this.autoConfirmTriggered = true;
    this.applyInitialSettingsToDropdowns();
    setTimeout(() => {
      this.confirmClick();
      $("#filter").collapse("hide");
      if (appConfig.initialSettings.redirectAfterLogin) {
        this._router.navigate(["/" + appConfig.initialSettings.redirectAfterLogin]);
      }
    }, 500);
  }

  ngOnInit() {
    this.removeOnMobileDevice();
    if (appConfig.initialSettings?.enabled) {
      this.startDate = this.resolveDate(appConfig.initialSettings.dateFrom);
      this.endDate = this.resolveDate(appConfig.initialSettings.dateTo);
    } else {
      this.startDate = new Date(new Date().getFullYear() - 1, 11, 31);
      this.endDate = new Date();
    }
    this.getCurrencies();
    this.getUserInfo();
  }

  ngAfterContentInit() {
    this.initCurrencyDropdown();
    this.initDatePickers();
    if (appConfig.initialSettings && appConfig.initialSettings?.enabled) {
      $("#filter").collapse("hide");
    }
  }

  ngOnDestroy() {
    this.assetCategorySubscription.unsubscribe();
    this.currAnalysisSubscription.unsubscribe();
    this.performanceChartSubscription.unsubscribe();
    this.transVolumeSubscription.unsubscribe();
    this.portfDetailsSubscription.unsubscribe();
    this.crossRatesSubscription.unsubscribe();
    this.transSubscription.unsubscribe();
    this.portfolioSubscription.unsubscribe();
    this.newsSubscription.unsubscribe();
    this.reportSubscription.unsubscribe();
    this.clientContactsSubscription.unsubscribe();
  }

  selectLanguage(lang) {
    this.languageLoading = true;
    kendo.ui.progress($(".language-loading"), true);
    setTimeout(() => {
      this._localize.setLocale(lang);
      this._authService.logout();
      this._insaService.clearData();
    }, 2500);
    // this._localize.applyTranslations(); // update whole view instead of just this component
    // this.initDatePickers();
    // this.recreateMultiselect();
  }

  // Settings -> Special Functions -> Change Password.
  // Even though the user is logged in, a fresh TOTP / certificate check
  // (depending on isPrivatePartner) is required first.
  // AuthService.requestPasswordChange() routes to the right verifier
  // (/twoFactorValidate or /twoFactorCertificate) on success - same as
  // requestPasswordReset() does for forgot-password; here we only handle
  // the "can't self-serve" and error cases.
  changePassword() {
    if (this.passwordChangeRequesting) return;
    this.passwordChangeRequesting = true;
    kendo.ui.progress($(".language-loading"), true);

    this._authService.requestPasswordChange().subscribe({
      next: (res) => {
        kendo.ui.progress($(".language-loading"), false);
        this.passwordChangeRequesting = false;

        if (!res || res.canSelfServe === false || !res.token) {
          SharedMethodsModule.addNotification(
            "#notificationPasswordChange",
            res?.message ||
              this._localize.getLocalizedResource("Res1649") ||
              "Promena lozinke nije dostupna za ovaj nalog. Obratite se podršci.",
            false,
          );
        }
      },
      error: (err) => {
        kendo.ui.progress($(".language-loading"), false);
        this.passwordChangeRequesting = false;
        SharedMethodsModule.addNotification(
          "#notificationPasswordChange",
          err?.error?.message ||
            this._localize.getLocalizedResource("Res1711") ||
            "Pokretanje promene lozinke nije uspelo. Pokušajte ponovo.",
          false,
        );
      },
    });
  }
  // $('#filter').on('shown.bs.modal', function () {
  //     $('#myInput').trigger('focus')
  //   })


  onConsolidateAllPositionsChange(event: Event): void {
  this.consolidateAllPositions = (event.target as HTMLInputElement).checked;

    if (this.consolidateAllPositions) {
      this.processingOnPortfolioLevel = false;
    }
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-settings-and-tiles/settings.component.ts